import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyCustomForm, { FormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyCustomForm';
import { Loading, LoadingError } from '@components/Base';

import { usePersonalAccidentQuoteFetch } from '../hook';
import { personalAccidentQuoteCustom, PersonalAccidentQuoteCustomPayload } from '../action';
import { useInitialValues } from './hook';

const PersonalAccidentQuoteBuyCustomPage = () => {
  const dispatch = useDispatch();
  const personalAccidentQuote = usePersonalAccidentQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(personalAccidentQuote)) return <Loading />;
  if (isNull(personalAccidentQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { personalAccidentPlanName, orderNumber } = personalAccidentQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: PersonalAccidentQuoteCustomPayload = { ...values, orderNumber };
    dispatch(personalAccidentQuoteCustom(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyCustomForm initialValues={initialValues} onSubmit={handleSubmit} />
        </Col>

        <RightCol {...personalAccidentQuote} planName={personalAccidentPlanName} />
      </Row>
    </Container>
  );
};

export { PersonalAccidentQuoteBuyCustomPage };
